import React from 'react';
import 'react-step-progress-bar/styles.css';
import { ProgressBar, Step } from 'react-step-progress-bar';
import { IStatus } from '../../types/project';
import { Box } from '@mui/material';
import { getSalesStatusCodes } from '../../utils/Functions';

const StepProgressBar = (props: any) => {
  const { status, steps, project } = props;

  function calculatePercent(status: string) {
    let percent = 100 / 6;
    switch (status) {
      case 'A':
      case 'H':
        return 0;
      case 'P':
      case 'RL':
        return percent;
      case 'IP':
      case 'LOFS':
        return percent * 2;
      case 'O':
      case 'LIST':
        return percent * 3;
      case 'S':
      case 'TOTS':
        return percent * 4;
      case 'C':
      case 'LC':
        return percent * 5;
      case 'F':
      case 'L':
        return percent * 6;
      default:
        // Custom sales-category statuses (e.g. brokerage-specific sale codes) count as fully
        // sold, same as F/L - Conditional/Leased Conditional are excluded since they already
        // have their own earlier step above.
        return getSalesStatusCodes(project).filter((code: string) => code !== 'C' && code !== 'LC').includes(status) ? percent * 6 : 0;
    }
  }

  return (
    <Box
      sx={{
        marginTop: '20px',
        padding: '10px',
      }}
    >
      <ProgressBar percent={calculatePercent(status)}>
        {steps.map((step: IStatus, index: number) => {
          return (
            <Step key={index}>
              {({ accomplished, index }: any) => (
                <Box
                  sx={{
                    backgroundColor: step.color,
                    color: '#000',
                    padding: '5px 7px',
                    border: '1px solid #000',
                    borderRadius: '10px',
                    fontSize: '20px',
                  }}
                  className={`indexedStep ${accomplished ? 'accomplished' : ''}`}
                >
                  {step.code}
                </Box>
              )}
            </Step>
          );
        })}
      </ProgressBar>
    </Box>
  );
};

export default StepProgressBar;
